import { fetcher } from 'utils/axios';
import { BulkChatUsersActionsParams } from 'types/chat/api-types';
import { CompanyPhoneConfig } from 'types/company-platforms/companyPhoneConfig';
import { ChatUserModel } from 'types/chat-users/chat-user';
import { MessageModel } from 'types/chat/messages/message';
import { ChatUserConfigType } from 'types/chat/props';

export const getChatUser = async (id: number) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/contacts/getLegacy',
        {
          data: {
            id,
          },
        },
      ],
      'api',
    );

    if (data?.result !== false) {
      return data.contact as ChatUserModel;
    } else return null;
  } catch (error) {
    console.warn('getChatUser error: ', error);
    return null;
  }
};
export const getChatUserByPhoneNumber = async (phoneNumber: string) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/contacts/getLegasyByPhone',
        {
          data: {
            phoneNumber,
          },
        },
      ],
      'api',
    );

    if (data) {
      return data as {
        contact: Array<ChatUserModel>;
        lastIncomingMessage: MessageModel | null;
        lastMessage: MessageModel | null;
      };
    } else return null;
  } catch (error) {
    console.warn('getChatUser error: ', error);
    return null;
  }
};

export const createChatUser = async (
  firstName: string,
  lastName: string,
  phone: string,
  email: string,
  companyPhoneConfig?: CompanyPhoneConfig,
) => {
  try {
    const params = {
      firstName,
      lastName,
      phone,
      email,
      isFireberry: false,
      companyPhoneConfig,
    };

    const data = await fetcher('post', ['/api/services/CreateChatUser', { data: params }], 'history');
    
    // Debug logging
    console.log('CreateChatUser API response:', data);
    console.log('Response type:', typeof data);
    console.log('Response keys:', data ? Object.keys(data) : 'null');
    
    return data as
      | ChatUserModel
      | {
          message: string;
        };
  } catch (error) {
    console.warn('createChatUser error: ', error);
    return null;
  }
};

export const fetchGetChatUserConfig = async (phone: string) => {
  try {
    const data = await fetcher('get', `/api/services/getChatUserConfig?chatUserPhoneId=${phone}`, 'history');
    if (data)
      return data as {
        result: boolean;
        configObj: string;
      };
    else return null;
  } catch (error) {
    console.warn('getChatUserConfig error: ', error);
    return null;
  }
};

//* Chat users bulk actions
export const bulkChatUsersActions = async (params: BulkChatUsersActionsParams) => {
  try {
    const data = await fetcher('post', ['/api/services/bulkChatUserActions', { data: params }], 'history');
    return data;
  } catch (error) {
    console.warn('bulkChatUsersActions error: ', error);
    return null;
  }
};
export const fetchMakeChatUserUnread = async (phone: string, messageId: string | number) => {
  return await bulkChatUsersActions({
    bulkActionName: 'setUnread',
    chatUsersList: [phone],
    messageList: [Number(messageId)],
  });
};
export const fetchMakeChatUserRead = async (id: number) => {
  try {
    await fetcher(
      'put',
      [
        '/api/v1/contacts/setRead',
        {
          data: {
            id,
          },
        },
      ],
      'history',
    );
  } catch (error) {
    console.warn('makeChatUserRead error', error);
  }
};
export const fetchUpdateChatUserIcon = async (phone: string) => {
  try {
    const data = await fetcher(
      'get',
      [
        '/api/services/getChatUserWhatsappUserPick',
        {
          data: {
            whatsappPhoneNumberId: phone,
          },
        },
      ],
      'history',
    );

    return data;
  } catch (error) {
    console.warn('updateChatUserIcon error: ', error);
    return null;
  }
};
export const fetchUpdateChatUserDontDisturb = async (phone: string, state: boolean) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/services/SetChatUserDontDisturb',
        {
          data: {
            phone: phone,
            dontDisturb: state,
          },
        },
      ],
      'history',
    );
    return data;
  } catch (error) {
    console.warn('updateChatUserDontDisturb error: ', error);
    return null;
  }
};
export const fetchDeleteChatUsers = async (list: string[]) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/services/deleteChatUser',
        {
          data: list,
        },
      ],
      'history',
    );
    return data;
  } catch (error) {
    console.warn('deleteChatUsers error: ', error);
    return null;
  }
};

//* update functions
export const updateChatUserRelationToCompanyCustomer = async ({
  OwnerCompanyCustomerId,
  ChatUserRole,
  ChatUserPhoneNumberId,
}: {
  OwnerCompanyCustomerId: number | null;
  ChatUserRole: string | null;
  ChatUserPhoneNumberId: string | null;
}) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/companyCustomer/updateChatUserRelationToCompanyCustomer',
        {
          data: {
            OwnerCompanyCustomerId,
            ChatUserRole,
            ChatUserPhoneNumberId,
          },
        },
      ],
      'history',
    );
    if (data)
      return data as {
        result: boolean;
        OwnerCompanyCustomerId: number | null;
        ChatUserRole: string | null;
      };
    else return null;
  } catch (error) {
    console.warn('updateChatUserRelationToCompanyCustomer error: ', error);
    return null;
  }
};
export const fetchSaveChatUserConfig = async (chatUserPhoneId: string, configObject: ChatUserConfigType) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/services/saveChatUserConfig',
        {
          data: {
            chatUserPhoneId,
            configJsonString: JSON.stringify(configObject),
          },
        },
      ],
      'history',
    );
    return data as {
      result: boolean;
      message: string;
    };
  } catch (error) {
    console.warn('saveChatUserConfig error: ', error);
    return null;
  }
};
